import { Route } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotImplementedComponent } from './not-implemented/not-implemented.component';
import { TeaByTypeComponent } from './tea-by-type/tea-by-type.component';
import { TeaByRegionComponent } from './tea-by-region/tea-by-region.component';
import { TeaItemComponent } from './tea-item/tea-item.component';
import { TeaByFlavourComponent } from './tea-by-flavour/tea-by-flavour.component';
import { TeaItemListComponent } from './tea-item-list/tea-item-list.component';
import { CartViewComponent } from './cart-view/cart-view.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CheckoutStatusComponent } from './checkout-status/checkout-status.component';
import { OrderComponent } from './order/order.component';
import { ContactComponent } from './contact/contact.component';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { FrequentlyAskedQuestionsComponent } from './frequently-asked-questions/frequently-asked-questions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { VdpComponent } from './vdp/vdp.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { RefundsPolicyComponent } from './refunds-policy/refunds-policy.component';
import { OrderResolver } from './order/order.resolver';
import { TeaByTypeResolver } from './tea-by-type/tea-by-type.resolver';
import { TeaByFlavourResolver } from './tea-by-flavour/tea-by-flavour.resolver';
import { TeaByRegionResolver } from './tea-by-region/tea-by-region.resolver';
import { TeaItemResolver } from './tea-item/tea-item.resolver';
import { TeaItemListResolver } from './tea-item-list/tea-item-list.resolver';

export const appRoutes: Route[] = [
  {
    path: 'maintenance',
    component: MaintenanceModeComponent,
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent,
  },
  {
    path: '',
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'about',
        component: AboutComponent,
      },
      {
        path: 'tea-type',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'tea-type/:tea-type-slug',
        redirectTo: '/specialty-tea/:tea-type-slug',
      },
      {
        path: 'specialty-tea/:tea-type-slug',
        component: TeaByTypeComponent,
        resolve: {
          teaData: TeaByTypeResolver,
        },
      },
      {
        path: 'matcha',
        redirectTo: '/matcha-tea',
        pathMatch: 'full',
      },
      {
        path: 'matcha/:tea-type-slug',
        redirectTo: '/matcha-tea/:tea-type-slug',
      },
      {
        path: 'matcha-tea',
        component: TeaByTypeComponent,
        data: { teaTypeSlug: 'matcha' },
        resolve: {
          teaData: TeaByTypeResolver,
        },
      },
      {
        path: 'matcha-tea/:tea-item-slug',
        component: TeaItemComponent,
        resolve: {
          teaItemData: TeaItemResolver,
        },
      },
      {
        path: 'tisane',
        redirectTo: '/herbal-tea',
        pathMatch: 'full',
      },
      {
        path: 'tisane/:tea-type-slug',
        redirectTo: '/herbal-tea/:tea-type-slug',
      },
      {
        path: 'herbal',
        redirectTo: '/herbal-tea',
        pathMatch: 'full',
      },
      {
        path: 'herbal/:tea-type-slug',
        redirectTo: '/herbal-tea/:tea-type-slug',
      },
      {
        path: 'herbal-tea',
        component: TeaByTypeComponent,
        data: { teaTypeSlug: 'herbal-tea' },
        resolve: {
          teaData: TeaByTypeResolver,
        },
      },
      {
        path: 'herbal-tea/:tea-item-slug',
        component: TeaItemComponent,
        resolve: {
          teaItemData: TeaItemResolver,
        },
      },
      {
        path: 'tea-region/:tea-region-slug',
        component: TeaByRegionComponent,
        resolve: {
          regionData: TeaByRegionResolver,
        },
      },
      {
        path: 'tea-flavour/:tea-flavour-slug',
        component: TeaByFlavourComponent,
        resolve: {
          flavourData: TeaByFlavourResolver,
        },
      },
      {
        path: 'tea-wares',
        component: TeaByTypeComponent,
        data: { teaTypeSlug: 'tea-wares' },
        resolve: {
          teaData: TeaByTypeResolver,
        },
      },
      {
        path: 'tea-wares/:tea-item-slug',
        component: TeaItemListComponent,
        resolve: {
          teaItemListData: TeaItemListResolver,
        },
      },
      {
        path: 'gifts',
        component: NotImplementedComponent,
        children: [
          {
            path: ':slug',
            component: NotImplementedComponent,
          },
        ],
      },
      {
        path: 'tea-item/:tea-item-slug',
        component: TeaItemComponent,
        resolve: {
          teaItemData: TeaItemResolver,
        },
      },
      {
        path: 'cart',
        component: CartViewComponent,
      },
      {
        path: 'checkout',
        component: CheckoutComponent,
      },
      {
        path: 'checkout/:sessionId',
        component: CheckoutStatusComponent,
      },
      {
        path: 'order/:orderId',
        redirectTo: '/sencha-steep-in-transit/:orderId',
      },
      {
        path: 'sencha-steep-in-transit/:orderId',
        component: OrderComponent,
        resolve: {
          order: OrderResolver,
        },
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'faq',
        redirectTo: '/frequently-asked-questions',
      },
      {
        path: 'frequently-asked-questions',
        component: FrequentlyAskedQuestionsComponent,
      },
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
      },
      {
        path: 'vdp',
        redirectTo: '/vulnerability-disclosure-program',
      },
      {
        path: 'vulnerability-disclosure-program',
        component: VdpComponent,
      },
      {
        path: 'tos',
        redirectTo: '/terms-of-service',
      },
      {
        path: 'terms-of-service',
        component: TermsOfServiceComponent,
      },
      {
        path: 'refunds',
        redirectTo: '/refunds-policy',
      },
      {
        path: 'refunds-policy',
        component: RefundsPolicyComponent,
      },
      {
        path: 'beyond-the-brew',
        component: NotFoundComponent,
        data: { isDirectNavigation: true },
      },
      {
        path: '**',
        redirectTo: '/beyond-the-brew',
      },
    ],
  },
];
